module.exports = __webpack_public_path__ + "img/fi-korean-food-1200x790.205408d3.jpg";